import React, { createContext, useState, useContext } from "react";
import { Order, OrderLineItem } from "./types";

type AccountPageContextType = {
  orders: Order[];
  selectedOrder: Order;
  selectedLineItem: OrderLineItem;
  setSelectedOrder: (orderName: string) => void;
  setSelectedLineItem: (orderName: string, lineItemKey: string) => void;
} | null;

type AccountPageProviderProps = {
  orders: Order[];
  children: React.ReactNode;
};

const AccountPageContext = createContext<AccountPageContextType>(null);

export const AccountPageProvider = ({
  orders,
  children,
}: AccountPageProviderProps) => {
  const [selectedOrder, setSelectedOrder] = useState<Order>(orders[0]);
  const [selectedLineItem, setSelectedLineItem] = useState<OrderLineItem>(
    orders[0].lineItems[0]
  );

  const filterOrder = (orderName: string) =>
    orders.find((order) => order.name === orderName) || orders[0];

  const handleSetSelectedOrder = (orderName: string) => {
    const order = filterOrder(orderName);
    setSelectedOrder(order);
  };

  const handleSetSelectedLineItem = (
    orderName: string,
    lineItemKey: string
  ) => {
    const filteredOrder = filterOrder(orderName);
    const lineItem =
      filteredOrder.lineItems.find(
        (lineItem) => lineItem.key === lineItemKey
      ) || filteredOrder.lineItems[0];
    setSelectedLineItem(lineItem);
    setSelectedOrder(filteredOrder);
  };

  return (
    <AccountPageContext.Provider
      value={{
        orders,
        selectedOrder,
        selectedLineItem,
        setSelectedOrder: handleSetSelectedOrder,
        setSelectedLineItem: handleSetSelectedLineItem,
      }}
    >
      {children}
    </AccountPageContext.Provider>
  );
};

export const useAccountpageContext = () => {
  return useContext(AccountPageContext);
};
